// TEMPORARY - Buy/Sell are auto-processed naira trades, so Ghana/Kenya users
// are sent to support instead of the trade screen. When crypto trading goes
// manual, flip RESTRICT_NON_NIGERIA_TRADE to false (or delete this file and
// its usages in auto-trade.vue) and everyone trades like Nigerian users.
export const RESTRICT_NON_NIGERIA_TRADE = true

export const isTradeRestricted = (countryName) =>
  RESTRICT_NON_NIGERIA_TRADE && countryName !== 'Nigeria'
